import { Flex } from 'components/uiKit'

import s from './BgBox.module.scss'

type BgBoxProps = {
  children: React.ReactNode
  py?: number
  style?: React.CSSProperties
}

export const BgBox = ({ children, py, style }: BgBoxProps) => {
  return (
    <Flex
      className={s.box}
      style={{
        padding: `${py ?? 15}px 32px ${py ?? 15}px 32px`,
        ...style,
      }}
    >
      {children}
    </Flex>
  )
}
